import {AfterViewInit, Component, OnInit, ViewEncapsulation} from '@angular/core';
import {IDialogView} from '@shared/components/ok-cancel-dialog/ok-cancel-dialog.component';
import {DialogModel} from '@shared/models/dialog.model';

@Component({
    standalone: false,
    selector: 'particle-rename-title-dialog',
  templateUrl: './rename-title-dialog.component.html',
  styleUrls: ['./rename-title-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class RenameTitleDialogComponent implements OnInit, IDialogView, AfterViewInit {

  data: DialogModel;
  constructor() {

  }

  ngOnInit() {

  }
  ngAfterViewInit (): void {
  }
  onOkClicked(): boolean {
    if (!this.data.input.name || this.data.input.name.length === 0) {
      return false;
    }
    return true;
  }
}
